import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import policy_doc from '@/assets/documents/OP Privacy policy 2026_06_29.md';
import LogoCard from '@/LogoCard';

export default ({ showTitle = false }) => {
  return (
    <div className="container-fluid px-5">
      {showTitle &&
        <div className="text-center">
          <LogoCard className="mt-3 mb-5" height={100} />
        </div>
      }
      <Markdown
        children={policy_doc}
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={{
        ul: ({ node, ...props }) => (
          <ul style={{ margin: 0, paddingLeft: '1.25rem' }} {...props} />
        ),
        h1: 'h3',
        h2: 'h4',
        h3: 'h4',
        a: (props) => <a {...props} target="_blank" rel="noopener noreferrer" />,
        code: ({ inline, children }) =>
          !inline ? (
          <pre style={{ background: "#f6f8fa", padding: "0.75rem", borderRadius: "6px" }}>
            <code>{children}</code>
          </pre>
          ) : (
          <code style={{ background: "#eee", padding: "0.2rem 0.4rem", borderRadius: "4px" }}>{children}</code>
          )
        }}
      />
    </div>
  );
};
